import React from 'react';
import TextField from '../../Components/FormGroup/TextField';
import { Col } from 'reactstrap';
import { validatePhone, validatePostcode } from '../../Components/FormGroup/Validator';
import { Header, ResponsiveRow } from '../../Components/PageComponents';

function RegisterEmployeePage() {

    return (
        <>
            <Header>Home Details</Header>
            <ResponsiveRow>
                <Col>
                    <TextField type="phone" name="home_tel" label="Home Telephone" required={true} maxlength={12} validation={validatePhone} />
                </Col>
                <Col>
                    <TextField type="phone" name="mobile_tel" label="Mobile Number" required={true} maxlength={12} validation={validatePhone} />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name="home_address1" label="Home Address" required={true} />
                </Col>
                <Col>
                    <TextField name="home_address2" label="Home Address Line 2" />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col>
                    <TextField name="home_address3" label="City/Town" required={true} />
                </Col>
                <Col>
                    <TextField name="home_address4" label="County" />
                </Col>
            </ResponsiveRow>
            <ResponsiveRow>
                <Col md={6}>
                    <TextField name="home_postcode" label="Home Postcode" required={true} validation={validatePostcode} maxlength={8} />
                </Col>
            </ResponsiveRow>
        </>
    );
}
export default RegisterEmployeePage;
